import React, {Component} from 'react'
import {auth} from "../../../firebase/index";
import {byPropKey} from "../../utils";
import {ERROR_FORM_VALIDATION} from "../../../constants/messages";
import {ACCOUNT} from "../../../constants/routes";
import {
    showChangeProfileInfoFailureNotification,
    showChangeProfileInfoSuccessNotification
} from "../../notifications/live";

/**
 * Initial/ fallback state
 */
const INITIAL_STATE = {
    error: null
};

/**
 * Form component for the change profile info page.
 */
class ChangeProfileInfoForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...INITIAL_STATE,
            displayName: '',
            email: ''
        };
    }

    componentDidMount() {
        this.setState(byPropKey('displayName', auth.getCurrentUserDisplayName()));
        this.setState(byPropKey('email', auth.getCurrentUserEmail()));
    }

    /**
     * Called when the form is submitted.
     * Executes a password change request on firebase or handles an error if failed.
     */
    onSubmit = (event) => {
        // Validate form fields on backend - NEVER trust data from user
        if (this.isInvalid()) {
            this.setState(byPropKey('error', new Error(ERROR_FORM_VALIDATION)));

        } else {
            const userProfile = {
                displayName: this.state.displayName
            };
            // 1. Attempt a password update for the current user
            auth.doUpdateProfile(userProfile)
                .then(() => {
                    //2. Update display name in the parent component
                    // (somehow firebase doesn't listen to less important profile info changes so we gotta handle this.)
                    this.props.updateDisplayName(this.state.displayName);

                    // 3. Reset the state
                    this.setState(() => ({
                        ...INITIAL_STATE
                    }));

                    // 4. Manually refresh the page to load the new details.
                    this.props.history.push(ACCOUNT);

                    // 5. Display user profile update success notification.
                    showChangeProfileInfoSuccessNotification();
                })
                .catch(error => {
                    showChangeProfileInfoFailureNotification();
                    this.setState(byPropKey('error', error));
                });
        }

        // Prevents the default reload of a browser which would otherwise be natural behaviour when submitting a form.
        event.preventDefault();
    };

    /**
     * @returns {boolean} {@code true} if the current state variables are
     * invalid and should not be entered into the database.
     */
    isInvalid = () => {
        const emptyDisplayName = this.state.displayName === "";
        return emptyDisplayName;
    };

    render() {
        const isInvalid = this.isInvalid();

        return (
            <form onSubmit={this.onSubmit}>
                <div className="form-group">
                    <label htmlFor="txtDisplayName">Display Name: </label>
                    <input
                        id="txtDisplayName"
                        value={this.state.displayName || ''}
                        className="form-control input-lg"
                        onChange={event => this.setState(byPropKey('displayName', event.target.value))}
                        type="text"
                        placeholder="New Display Name"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="txtEmail">Email: </label>
                    <input
                        id="txtEmail"
                        value={this.state.email || ''}
                        className="form-control input-lg"
                        onChange={event => this.setState(byPropKey('email', event.target.value))}
                        type="text"
                        placeholder="New Email"
                        disabled
                    />
                </div>
                <button
                    disabled={isInvalid}
                    className="btn btn-lg btn-primary btn-block"
                    style={{width: '62%', margin: '0 19%'}}
                    type="submit"
                >
                    Save
                </button>

                {
                    this.state.error &&
                        <p>{this.state.error.message}</p>
                }
            </form>
        );
    }
}

export default ChangeProfileInfoForm;



// WEBPACK FOOTER //
// ./src/components/account/changeprofileinfo/ChangeProfileInfoForm.jsx